export const ADD_PROMO_CODE_HOST_RELATION = "ADD_PROMO_CODE_HOST_RELATION"
export const ADD_PROMO_CODE_HOST_RELATION_SUCCESSFUL = "ADD_PROMO_CODE_HOST_RELATION_SUCCESSFUL"
export const ADD_PROMO_CODE_HOST_RELATION_FAILED = "ADD_PROMO_CODE_HOST_RELATION_FAILED"
export const ADD_PROMO_CODE_HOST_RELATION_RESET = "ADD_PROMO_CODE_HOST_RELATION_RESET"

